import Backbone from 'backbone'
import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import FormView from 'scoreboard/components/form-view'
import template from './data-source-form-dialog.hbs'
import DataSourceForm from './dataset-data-source-form'

const DataSourceFormDialog = Backbone.View.extend({
	tagName: 'form',

	className: 'set-data-source field-form',

	/**
	 * View constructor to use for the actual data source form; can be overridden
	 * to provide an extension with different settings
	 */
	formConstructor: DataSourceForm,

	/**
	 * @param {Object} options - see DataSourceForm.initialize()
	 */
	initialize: function(options = {}) {
		this.options = options

		let ThisFormView = FormView.extend({
			test: this.test.bind(this)
		})

		this.formView = new ThisFormView({
			el: this.el,
			submit: this.submit.bind(this),
			guard: false,
			allowCleanSubmission: true
		})

		this.dataSourceForm = new this.formConstructor(_.extend({
			formView: this.formView
		}, options))
	},

	render: function () {
		this.$el.empty().append(template(this.context()))

		this.$('.dialog-body-content').append(this.dataSourceForm.el)
		this.dataSourceForm.render()

		this.formView.start()

		return this
	},

	context: function() {
		let title = i18n.get('datasets.choose.columns.setDataSource')
		return { title }
	},

	test: function () {
		return this.dataSourceForm.test()
	},

	submit: function () {
		// Validation is done asynchronously when primary button is clicked
		// (specifically an XHR for equation validation), so we have to
		// listen for the 'done' event
		this.listenTo(this.dataSourceForm, 'done', (dataSource, dataset) => {
			this.trigger('done', dataSource, dataset)
		})
		this.dataSourceForm.submit()
	},

	remove: function () {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([ this.formView, this.dataSourceForm ], 'remove')
	}
})

export default DataSourceFormDialog

DataSourceFormDialog.__filename__ = 'datasets/data-source-form-dialog.js'
